import styled from '@emotion/styled'
import { Row, color, spacer } from 'stylist'

const Section = styled(Row)`
  padding-top: ${spacer(7)};
  padding-bottom: ${spacer(7)};
  background: ${({ background, theme }) => color(background, { theme })};
`

export default Section



// WEBPACK FOOTER //
// ./src/routes/home/components/Section.js